import { FormControl } from '@angular/forms';

export class InputsValidators {

  static regexpEmail: RegExp = new RegExp(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/);

  static validName(fc: FormControl): { validUsername: boolean } | null {
    if (fc.value.toLowerCase() === 'abc123') {
      return ({ validUsername: true });
    } else {
      return (null);
    }
  }

  static validEmail(email: string): boolean {
    return this.regexpEmail.test(String(email).toLowerCase());
  }
}
